export const DEVICE_CONSTANTS = {
    CAMERA_OFFLINE_STATUS: "offline",
    CAMERA_ONBOARDED_STATUS: "Onboarded",
    CAMERA_ONLINE_STATUS: "Online",
    CCD_ONLINE_STATUS: "online",
    CAMERA_NOT_CALIBRATED_STATUS: "Not Calibrated",
    CAMERA_CALIBRATING_STATUS: "Calibrating",
    CAMERA_STATUS_READY: "ready",
    CAMERA_STATUS_REGISTERED: "registered",
    CAMERA_TYPE_MANUAL: "Manual",
    RTSP_CAMERA_OFFLINE_MESSAGE: "Go to the Camera Details page and re-enter the RTSP URL to reconnect",
    STORAGE_KEYS: {
        COMPANION_DEVICES_LIST: "companionDevicesList",
        CAMERAS_LIST: "camerasList",
        FOV_LIST: "fovList",
        ROI_LIST: "roiList",
        DEVICE_LIST: "deviceList"
    },
    ALL_CCDS_OFFLINE: "All companion devices are offline",
    NO_DISCOVERED_CAMERAS: "No discovered cameras",
    FAILED_TO_UPDATE_CAMERA_LIST: "Failed to update the camera list.",
    CCDs_OFFLINE_BANNER_TITLE(offlineCCDnames, offlineCCDsCount ) {
        return offlineCCDnames + " Companion Device" + (offlineCCDsCount === 1 ? " is" : "s are") + " offline.";
    },
    NO_CCD_ASSOCIATED(siteName) {
        return `No companions have been added to the site ${siteName}`;
    },
};

export const COMPANION_OFFLINE_NOTIFICATION = {
  type: "Information",
  title: "Companion device is offline",
  subtitle: "Please make sure the device is on and connected to the internet.",
  showNotification: true,
  priority: "critical",
};